module.exports = __webpack_public_path__ + "media/images/japan/one-ticket-5cb5f1166baa73bd7ebf68c395c69dc7.svg";